import React from "react";
import { Dropdown, IDropdownOption, IDropdownStyles } from "@fluentui/react";

export type RoleFilterValue = "all" | "Owner" | "Guest";

const ROLE_OPTIONS: IDropdownOption[] =
[
    { key: "all", text: "Todos" },
    { key: "Owner", text: "Propietario" },
    { key: "Guest", text: "Solo Lectura" }
];

export interface RoleFilterDropdownProps
{
    value: RoleFilterValue;
    onChange: (value: RoleFilterValue) => void;
}

const RoleFilterDropdown: React.FC<RoleFilterDropdownProps> = ({ value, onChange }) =>
{
    const handleChange = (_ev: React.FormEvent<HTMLDivElement>, option?: IDropdownOption) =>
    {
        if(option?.key !== undefined)
        {
            onChange(option.key as RoleFilterValue);
        }
    };

    const dropdownStyles: Partial<IDropdownStyles> =
    {
        dropdown: { minWidth: 180 },
        title:
        {
            color: "#CC214F !important",
            borderColor: "#95A0A1",
            selectors:
            {
                ":hover":
                {
                    borderColor: "#CC214F"
                }
            }
        },
        caretDown: { color: "#CC214F" },
        dropdownOptionText: { color: "#CC214F" }
    };

    return(
        <Dropdown placeholder="Filtrar por rol" options={ROLE_OPTIONS}
            selectedKey={value} onChange={handleChange}
            styles={dropdownStyles}
        />
    );
};

export default RoleFilterDropdown;